(() => {
  const launcherLabel = 'Pandit Ji se poochhein';
  const outerStyleId = 'ds-pandit-chat-outer';
  const runtimeStyleId = 'ds-pandit-chat-runtime';
  const observedRoots = new WeakSet();

  const outerStyles = `
    .activator {
      min-height: 54px !important;
      padding-inline: 18px !important;
      border: 1px solid rgba(126, 67, 22, .22) !important;
      border-radius: 999px !important;
      background: rgba(251, 245, 222, .96) !important;
      box-shadow: 0 12px 34px rgba(77, 37, 9, .2) !important;
      backdrop-filter: blur(12px) !important;
      font-weight: 600 !important;
      letter-spacing: .01em !important;
    }
    .activator__icon {
      display: grid !important;
      place-items: center !important;
      width: 26px !important;
      height: 26px !important;
      color: #9a4d16 !important;
    }
    .activator__icon > * { display: none !important; }
    .activator__icon::before {
      content: '🪔';
      font-size: 20px;
      line-height: 1;
    }
    .activator__indicator { background: #8f3d09 !important; }
  `;

  const runtimeStyles = `
    :host { --private-panel-width: 440px; }

    .activator {
      min-height: 54px !important;
      padding-inline: 18px !important;
      border: 1px solid rgba(126, 67, 22, .22) !important;
      border-radius: 999px !important;
      background: rgba(251, 245, 222, .96) !important;
      box-shadow: 0 12px 34px rgba(77, 37, 9, .2) !important;
      backdrop-filter: blur(12px) !important;
      font-weight: 600 !important;
      letter-spacing: .01em !important;
    }
    .activator__icon {
      display: grid !important;
      place-items: center !important;
      width: 26px !important;
      height: 26px !important;
      color: #9a4d16 !important;
    }
    .activator__icon > * { display: none !important; }
    .activator__icon::before {
      content: '🪔';
      font-size: 20px;
      line-height: 1;
    }

    .panel {
      border: 1px solid rgba(194, 143, 78, .34) !important;
      background: #fffaf0 !important;
      background-image:
        radial-gradient(circle at 10% 0%, rgba(235, 188, 112, .2), transparent 32%),
        linear-gradient(180deg, #fffaf0 0%, #fbf1d8 100%) !important;
      box-shadow: -18px 22px 55px rgba(45, 25, 12, .28) !important;
    }

    .panel__header {
      width: 100% !important;
      min-height: 82px !important;
      padding: 13px 15px !important;
      border-bottom: 1px solid rgba(237, 184, 92, .38) !important;
      background: #211f1e !important;
      color: #fffaf0 !important;
    }
    .panel__header-column--left { margin-left: auto !important; }
    .panel__sign-in { display: none !important; }
    .panel__chat-actions { display: none !important; }
    .panel__header-column--right { margin-left: 8px !important; }

    .ds-pandit-brand {
      display: flex;
      align-items: center;
      gap: 10px;
      min-width: 0;
      margin-right: auto;
      color: #fff;
      font-family: var(--shopify-chat-body-font-family);
    }
    .ds-pandit-brand__avatar {
      display: grid;
      place-items: center;
      flex: 0 0 38px;
      width: 38px;
      height: 38px;
      border: 1px solid rgba(241, 184, 83, .42);
      border-radius: 50%;
      background: rgba(255, 246, 220, .1);
      font-size: 22px;
      box-shadow: inset 0 0 0 3px rgba(255, 255, 255, .03);
    }
    .ds-pandit-brand__copy {
      display: grid;
      gap: 2px;
      min-width: 0;
    }
    .ds-pandit-brand__copy strong {
      color: #fff;
      font-family: var(--shopify-chat-heading-font-family);
      font-size: 18px;
      font-weight: 700;
      line-height: 1.1;
    }
    .ds-pandit-brand__copy span {
      overflow: hidden;
      color: #f2bd58;
      font-size: 11px;
      line-height: 1.2;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .ds-pandit-brand__copy span::before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      margin-right: 6px;
      border-radius: 50%;
      background: #63c174;
      box-shadow: 0 0 0 3px rgba(99, 193, 116, .14);
      vertical-align: 1px;
    }

    .panel__body {
      padding-top: 82px !important;
    }
    .new-chat-popover {
      border: 1px solid rgba(126, 67, 22, .14) !important;
      background: #fffaf0 !important;
    }
    .new-chat-popover__button--primary {
      background: #6b2f08 !important;
      color: #fff8e6 !important;
    }

    @media (max-width: 749px) {
      :host { --private-panel-width: 100%; }
      .panel__header {
        min-height: 76px !important;
        padding: 11px 12px !important;
      }
      .panel__body { padding-top: 76px !important; }
      .ds-pandit-brand { gap: 8px; }
      .ds-pandit-brand__avatar {
        flex-basis: 34px;
        width: 34px;
        height: 34px;
        font-size: 19px;
      }
      .ds-pandit-brand__copy strong { font-size: 16px; }
      .ds-pandit-brand__copy span { font-size: 10px; }
    }
  `;

  function addStyle(root, id, css) {
    if (!root || root.querySelector(`#${id}`)) return;
    const style = document.createElement('style');
    style.id = id;
    style.textContent = css;
    root.appendChild(style);
  }

  function watch(root) {
    if (!root || observedRoots.has(root)) return;
    observedRoots.add(root);
    new MutationObserver(applyBranding).observe(root, { childList: true, subtree: true });
  }

  function renameLauncher(root) {
    if (!root) return;
    root.querySelectorAll('.activator__label').forEach((label) => {
      if (label.textContent !== launcherLabel) label.textContent = launcherLabel;
    });
    root.querySelectorAll('.activator').forEach((button) => {
      if (button.getAttribute('aria-label') !== launcherLabel) {
        button.setAttribute('aria-label', launcherLabel);
      }
    });
  }

  function addPanditHeader(root) {
    const header = root && root.querySelector('.panel__header');
    if (!header) return;

    let brand = header.querySelector('.ds-pandit-brand');
    if (!brand) {
      brand = document.createElement('div');
      brand.className = 'ds-pandit-brand';
      brand.setAttribute('aria-label', 'Pandit Ji, Divine Shiva Vedic Guide');
      brand.innerHTML = `
        <span class="ds-pandit-brand__avatar" aria-hidden="true">🪔</span>
        <span class="ds-pandit-brand__copy">
          <strong>Pandit Ji</strong>
          <span>Divine Shiva · Vedic Guide</span>
        </span>
      `;
      header.prepend(brand);
    }

    const title = root.querySelector('#shopify-agent-panel-title');
    if (title && title.textContent !== 'Pandit Ji') title.textContent = 'Pandit Ji';
  }

  function applyBranding() {
    const chat = document.querySelector('shopify-chat');
    if (!chat) return false;

    chat.style.setProperty('--shopify-chat-bg-color', '#fbf5de');
    chat.style.setProperty('--shopify-chat-text-color', '#5d2a04');
    chat.style.setProperty('--shopify-chat-accent-bg-color', '#6b2f08');
    chat.style.setProperty('--shopify-chat-accent-text-color', '#fff8e6');
    chat.style.setProperty('--shopify-chat-border-radius', '22px');
    chat.style.setProperty('--shopify-chat-activator-offset', location.pathname.startsWith('/products/') ? '104px' : '20px');

    const outerRoot = chat.shadowRoot;
    if (!outerRoot) return true;
    addStyle(outerRoot, outerStyleId, outerStyles);
    renameLauncher(outerRoot);
    watch(outerRoot);

    const runtime = outerRoot.querySelector('shopify-agent-runtime');
    const runtimeRoot = runtime && runtime.shadowRoot;
    if (!runtimeRoot) return true;
    addStyle(runtimeRoot, runtimeStyleId, runtimeStyles);
    renameLauncher(runtimeRoot);
    addPanditHeader(runtimeRoot);
    watch(runtimeRoot);
    return true;
  }

  const pageObserver = new MutationObserver(applyBranding);
  pageObserver.observe(document.documentElement, { childList: true, subtree: true });

  let attempts = 0;
  const timer = window.setInterval(() => {
    attempts += 1;
    applyBranding();
    if (attempts >= 60) window.clearInterval(timer);
  }, 500);

  applyBranding();
})();
